import * as React from 'react';
import { __ } from '@bart.sk-eshop/react-i18n';
import { connectSsr } from '@bart.sk-eshop/ssr-service';
import { connect } from 'react-redux';

import {
  customerInfoSelector,
  fetchDeliveryAddresses,
  deliveryAddressesSelector,
  deliveryAddressesIsFetchingSelector,
} from './myAccountSlice';
import MyDeliveryAddresses from '../../components/MyAccount/MyDeliveryAddresses';
import API, { ThenArg } from '../../services/API';
import {
  BreadCrumbType,
  setBreadCrumbPath,
} from '../BreadCrumb/breadCrumbSlice';
import { langSelector } from '../App/selectors';
import MetaTags from '../../components/_helpers/MetaTags/MetaTags';

interface Props {
  user: any;
  dispatch: any;
  customerInfo: ThenArg<typeof API.getCustomerDetails>;
  deliveryAddresses: ThenArg<typeof API.getDeliveryAddresses>;
  isFetching: boolean;
  lang: string;
}

class MyDeliveryAddressesContainer extends React.Component<Props> {
  public static async getInitialProps(props) {
    const { dispatch } = props;
    try {
      dispatch(setBreadCrumbPath(BreadCrumbType.MY_ACCOUNT_DELIVERY_ADDRESSES));
      await dispatch(fetchDeliveryAddresses());
      return;
    } catch (exp) {
      console.log(exp);
      return;
    }
  }

  public render() {
    const { user, deliveryAddresses, isFetching } = this.props;
    return (
      <>
        <MetaTags
          tags={{
            title: __('Moj účet - Moje dodacie adresy'),
          }}
        />
        <MyDeliveryAddresses
          isFetching={isFetching}
          userId={user && user.id}
          deliveryAddresses={deliveryAddresses}
          refreshAddresses={this.refreshAddresses}
          lang={this.props.lang}
        />
      </>
    );
  }

  public refreshAddresses = async () => {
    const { dispatch } = this.props;
    try {
      await dispatch(fetchDeliveryAddresses(true));
    } catch (exp) {
      console.log(exp);
    }
  };
}

const mapStateToProps = state => {
  return {
    user: state.auth.user,
    customerInfo: customerInfoSelector(state),
    deliveryAddresses: deliveryAddressesSelector(state),
    isFetching: deliveryAddressesIsFetchingSelector(state),
    lang: langSelector(state),
  };
};

export default connect(mapStateToProps)(
  connectSsr({ displayName: 'MyDeliveryAddressesContainer' })(
    MyDeliveryAddressesContainer,
  ),
);
